module.exports = __webpack_public_path__ + "img/upload-formulario.c12536fa.jpg";